export let TaskStatusOptions: ITaskStatusOption[] = [
    { value: 0, text: 'Nieuw'},
    { value: 1, text: 'Open'},
    { value: 2, text: 'Bezig'},
    { value: 3, text: 'Uitgesteld'},
    { value: 4, text: 'Meer info nodig'},
    { value: 5, text: 'Gesloten'},
];

export let TaskTypeOptions: ITaskTypeOption[] = [
    { value: 0, text: 'Varia'},
    { value: 1, text: 'Telefoon'},
    { value: 2, text: 'Afspraak maken'},
    { value: 3, text: 'Afspraak'},
    { value: 4, text: 'Offerte maken'},
];
